import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DbContextService } from '../../../services/db-context.service';
import { Helper } from '../../common/helper';
import swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class OrderItemService {

  constructor(
    private http: HttpClient,
    private dbxService: DbContextService) { }

  getShipData() {
    return this.http.get(Helper.API_URL() + '/api/Maintenance/GetShipsDetails');
  }

  requestNewOrderListItem(itemDesc: string) {
    let paramObject = {
      'itemDesc': itemDesc
    }
    return this.http.post(Helper.API_URL() + '/api/orders/RequestNewOrderListItem', paramObject);
  }

  // Index DB -------------------------------------------------------------

  getOrderItemCreditsIndexDb(): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      this.dbxService.openDatabase().then(db => {
        const tx = db.transaction('OWS_tblOrderListItem', 'readwrite');
        let store = tx.objectStore('OWS_tblOrderListItem');
        let req = store.get("Credits").then(
          (res: any) => {
            resolve(res);
          });
      });
    });
    return promise;
  }

  saveOrderItemCreditsIndexDb(credits: number, updatedOffline: boolean): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      let obj = {
        'orderListItemId': 'Credits',
        'credits': credits,
        'updatedOffline': updatedOffline
      }

      this.dbxService.openDatabase().then(db => {
        const tx = db.transaction('OWS_tblOrderListItem', 'readwrite');
        let store = tx.objectStore('OWS_tblOrderListItem');
        tx.onabort = (event: any) => {
          const err = event.target?.error;
          if (err?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        };

        tx.onerror = (event: any) => {
          console.warn(event);
          const err = event.target?.error;
          if (err?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        };

        store.get("Credits").then(
          (res: any) => {
            if (res == null) {
              try {
                let req = store.add(obj);
                resolve(req);
              } catch (e: any) {
                if (e?.name === 'QuotaExceededError') {
                  this.handleQuotaExceeded();
                }
              }
            } else {
              try {
                let req = store.put(obj);
                resolve(req);
              } catch (e: any) {
                if (e?.name === 'QuotaExceededError') {
                  this.handleQuotaExceeded();
                }
              }
            }
          })
      });
    });
    return promise;
  }

  handleQuotaExceeded() {
    swal
      .fire({
        title: 'Error',
        html: '<span>IndexedDB storage qouta exceeded.</span>',
        icon: "error",
        confirmButtonText: "OK",
        allowOutsideClick: false,
        allowEscapeKey: false,
      })
      .then((result) => {
        if (result.value) {
        }
      });
  }
}
